import React from 'react';
import { Link } from 'react-router-dom';

const LAST_UPDATED = 'Febrero 2026';

const TermsAndConditions = () => {
  return (
    <article className="bg-gray-50 min-h-screen">
      <header className="bg-gray-800 text-white pt-28 pb-16 md:pt-64">
        <div className="contain px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl md:text-4xl font-bold mb-2">Términos y condiciones de servicio</h1>
          <p className="text-gray-300 text-lg">SALIENT Hub Multiservicios</p>
          <p className="text-gray-400 mt-1">Última actualización: {LAST_UPDATED}</p>
        </div>
      </header>

      <div className="contain px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="max-w-4xl mx-auto space-y-10 text-gray-700 leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">1. Identificación del prestador del servicio</h2>
            <p>
              SALIENT (en adelante “la Plataforma”) es un Hub digital multiservicios que ofrece soluciones tecnológicas, automatización, servicios de marketing digital, integración con WhatsApp Business API, comercialización de productos, intermediación inmobiliaria y servicios digitales diversos.
            </p>
            <p className="mt-3">
              El uso de la Plataforma implica la aceptación plena de los presentes Términos y Condiciones.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">2. Aceptación</h2>
            <p className="mb-3">Al registrarse, contratar servicios o utilizar la Plataforma, el Usuario declara:</p>
            <ul className="list-disc list-inside ml-2 space-y-1">
              <li>Ser mayor de edad.</li>
              <li>Tener capacidad legal para contratar.</li>
              <li>Aceptar estos Términos sin reservas.</li>
            </ul>
            <p className="mt-3">Si no está de acuerdo, debe abstenerse de utilizar los servicios.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">3. Descripción de los servicios</h2>
            <p className="mb-3">La Plataforma puede ofrecer, entre otros:</p>
            <ul className="list-disc list-inside ml-2 space-y-1">
              <li>Automatización y gestión de leads.</li>
              <li>Integraciones con WhatsApp Business API.</li>
              <li>Chatbots y automatizaciones.</li>
              <li>Creación de landing pages.</li>
              <li>Venta de productos físicos o digitales.</li>
              <li>Intermediación en bienes inmuebles.</li>
              <li>Servicios de agencia digital o de viajes.</li>
              <li>Desarrollo tecnológico.</li>
            </ul>
            <p className="mt-3">La disponibilidad puede variar sin previo aviso.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">4. Cuentas y registro</h2>
            <p className="mb-3">El Usuario es responsable de:</p>
            <ul className="list-disc list-inside ml-2 space-y-1">
              <li>Proporcionar información veraz.</li>
              <li>Mantener la confidencialidad de su cuenta.</li>
              <li>Toda actividad realizada bajo sus credenciales.</li>
            </ul>
            <p className="mt-3">La Plataforma podrá suspender cuentas en caso de uso indebido.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">5. Uso de WhatsApp Business API y automatizaciones</h2>
            <p className="mb-3">Cuando el Usuario contrate servicios relacionados con WhatsApp:</p>
            <ul className="list-disc list-inside ml-2 space-y-1">
              <li>Es responsable del contenido enviado.</li>
              <li>Debe cumplir con las políticas de Meta.</li>
              <li>Se prohíbe el envío de spam o mensajes masivos no autorizados.</li>
              <li>Se prohíbe el uso para actividades ilegales.</li>
            </ul>
            <p className="mt-3">La Plataforma no se hace responsable por suspensiones derivadas del mal uso del cliente.</p>
            <p className="mt-2">En caso de incumplimiento, la cuenta podrá cancelarse sin reembolso.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">6. Responsabilidad del contenido</h2>
            <p className="mb-3">El Usuario es el único responsable del contenido que:</p>
            <ul className="list-disc list-inside ml-2 space-y-1">
              <li>Publique.</li>
              <li>Automatice.</li>
              <li>Distribuya.</li>
              <li>Venda.</li>
            </ul>
            <p className="mt-3">La Plataforma actúa como intermediario tecnológico y no garantiza la veracidad de los contenidos publicados por terceros.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">7. Marketplace y venta de productos</h2>
            <p className="mb-3">Cuando la Plataforma facilite la compraventa:</p>
            <ul className="list-disc list-inside ml-2 space-y-1">
              <li>Puede actuar como intermediario.</li>
              <li>No garantiza la calidad de productos de terceros.</li>
              <li>Las disputas deberán resolverse entre comprador y vendedor.</li>
            </ul>
            <p className="mt-3">En productos propios, aplicarán las políticas específicas de garantía y devolución.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">8. Servicios inmobiliarios y de intermediación</h2>
            <p className="mb-3">La Plataforma puede actuar como intermediario digital. No garantiza:</p>
            <ul className="list-disc list-inside ml-2 space-y-1">
              <li>La disponibilidad final del inmueble.</li>
              <li>El cierre de operaciones.</li>
              <li>La solvencia de terceros.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">9. Servicios de viaje o reservas</h2>
            <p className="mb-3">En caso de ofrecer reservas o servicios turísticos:</p>
            <ul className="list-disc list-inside ml-2 space-y-1">
              <li>La Plataforma puede actuar como intermediario.</li>
              <li>No es responsable por cancelaciones de proveedores externos.</li>
              <li>Aplican políticas del proveedor correspondiente.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">10. Pagos y facturación</h2>
            <p className="mb-3">Los precios:</p>
            <ul className="list-disc list-inside ml-2 space-y-1">
              <li>Podrán estar en MXN.</li>
              <li>Pueden modificarse sin previo aviso.</li>
              <li>No incluyen impuestos salvo que se indique.</li>
            </ul>
            <p className="mt-3">La falta de pago podrá suspender servicios inmediatamente.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">11. Limitación de responsabilidad</h2>
            <p className="mb-3">La Plataforma no garantiza:</p>
            <ul className="list-disc list-inside ml-2 space-y-1">
              <li>Disponibilidad ininterrumpida 24/7.</li>
              <li>Ausencia de errores técnicos.</li>
              <li>Resultados comerciales específicos.</li>
            </ul>
            <p className="mt-3">En ningún caso será responsable por daños indirectos, lucro cesante o pérdidas derivadas del uso del servicio.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">12. Suspensión y cancelación</h2>
            <p className="mb-3">La Plataforma podrá suspender o cancelar cuentas cuando:</p>
            <ul className="list-disc list-inside ml-2 space-y-1">
              <li>Se detecte uso indebido.</li>
              <li>Se incumplan estos términos.</li>
              <li>Exista actividad sospechosa o ilegal.</li>
            </ul>
            <p className="mt-3">No habrá obligación de reembolso en caso de incumplimiento del Usuario.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">13. Propiedad intelectual</h2>
            <p className="mb-3">El software, diseño, marca y contenido de la Plataforma son propiedad de WEB4YOU.</p>
            <p className="mb-3">El Usuario no podrá:</p>
            <ul className="list-disc list-inside ml-2 space-y-1">
              <li>Copiar</li>
              <li>Revender</li>
              <li>Reproducir</li>
              <li>Modificar sin autorización expresa.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">14. Protección de datos</h2>
            <p>
              El tratamiento de datos personales se rige por la <Link to="/politica-de-privacidad" className="text-salient-primary hover:underline">Política de Privacidad</Link> publicada en la Plataforma y conforme a la legislación mexicana aplicable.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">15. Modificaciones</h2>
            <p>
              Estos Términos pueden actualizarse en cualquier momento. El uso continuo implica aceptación de las modificaciones.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4">16. Ley aplicable y jurisdicción</h2>
            <p className="mb-3">Estos Términos se rigen por las leyes de los Estados Unidos Mexicanos.</p>
            <p>Cualquier controversia será sometida a los tribunales competentes en México.</p>
          </section>
        </div>
      </div>
    </article>
  );
};

export default TermsAndConditions;
